import { Backdrop } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import Colors from "../../../global/Colors";
import LoadingIndicator from "../../../global/LoadingIndicator";
import Modal from "../../../global/Modal";
import ResponseModal from "../../../global/ResponseModal";

import ActionDetailField from "./components/ActionDetailField";
import AssignmentSection from "./components/AssignmentSection";
import CasesField from "./components/CasesField";
import DueDateField from "./components/DueDateField";
import LawFirmSection from "./components/LawFirmSection";
import ProviderSection from "./components/ProviderSection";
import useAddActionItemModal from "./hooks/useAddActionItemModal";

export default function AddActionItemModal(props) {
  const { addOpen, activeActionItem, externalRevalidate } = props;
  const {
    selectedCase,
    handleNewActionSubmit,
    patchAction,
    handleClose,
    openError,
    setOpenError,
    errorArray,
    isLoadingActionItem,
    casesFieldProps,
    assignmentSectionProps,
    lawFirmSectionProps,
    providerSectionProps,
    dueDateFieldProps,
    actionDetailFieldProps,
  } = useAddActionItemModal(props);

  const isEditing = !!activeActionItem;
  const shouldRenderDependentSections = isEditing || !!selectedCase;
  const dependentSectionsDisabled = isEditing && !selectedCase;

  return (
    <Modal
      open={addOpen}
      onClose={handleClose}
      actions={[
        {
          label: !activeActionItem ? "Add Action Item" : "Update",
          onClick: !activeActionItem
            ? () => handleNewActionSubmit({ externalRevalidate })
            : () => patchAction({ externalRevalidate, markDone: false }),
          className: "add-action",
          disabled: isLoadingActionItem,
        },
        ...(activeActionItem
          ? [
              {
                label: "Update and Complete",
                onClick: () => patchAction({ externalRevalidate, markDone: true }),
                className: "update-complete-action",
                disabled: isLoadingActionItem || activeActionItem?.status === "done",
              },
            ]
          : []),
      ]}
      title={!activeActionItem ? "Add Action Item" : "Edit Action Item"}
      actionsClassName={activeActionItem ? "!flex !flex-row !justify-center" : ""}
    >
      <div className="relative flex flex-col items-center w-full">
        {isLoadingActionItem && (
          <Backdrop
            open
            sx={{
              position: "absolute",
              zIndex: (theme) => theme.zIndex.modal + 1,
              color: Colors.white,
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              borderRadius: "5px",
            }}
          >
            <LoadingIndicator isLoading top="50%" left="45%" />
          </Backdrop>
        )}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <div className="flex flex-col w-full gap-4 bg-white">
            <CasesField {...casesFieldProps} />
            {shouldRenderDependentSections && (
              <>
                <AssignmentSection
                  {...assignmentSectionProps}
                  disabled={dependentSectionsDisabled}
                />
                <LawFirmSection {...lawFirmSectionProps} disabled={dependentSectionsDisabled} />
                <ProviderSection {...providerSectionProps} disabled={dependentSectionsDisabled} />
              </>
            )}
            <DueDateField {...dueDateFieldProps} />
            <ActionDetailField {...actionDetailFieldProps} />
          </div>
          <ResponseModal
            title={!activeActionItem ? "Error creating Action Item" : "Error updating Action Item"}
            isError
            openBool={openError}
            setOpenBool={setOpenError}
            errorMessage={errorArray}
          />
        </LocalizationProvider>
      </div>
    </Modal>
  );
}
